import { setStudioMode } from "@/lib/studioMode";
import { ALL_STYLES } from "@/lib/creatorConstants";

export const CREATOR_DRAFT_KEY = "elpm-creator-draft";

const ALIASES = {
  "gospel-reggae": ["gospel reggae", "reggae gospel", "christian reggae"],
  "gospel-rnb": ["gospel r&b", "gospel rnb", "urban gospel", "gospel soul"],
  "contemporary-gospel": ["contemporary gospel", "gospel"],
  worship: ["worship", "praise", "ccm", "contemporary christian", "religious", "hymn", "christian"],
  rnb: ["r&b", "rnb", "r & b", "quiet storm", "neo-soul", "neo soul"],
  hiphop: ["hip-hop", "hip hop", "rap", "boom bap", "drill"],
  edm: ["edm", "dance", "house", "electro", "synthwave"],
  lofi: ["lo-fi", "lofi"],
  latin: ["latin", "reggaeton", "salsa", "bachata"],
  cinematic: ["cinematic", "orchestral", "ambient", "classical"],
};

const escapeRe = (t) => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/** Best Creator style chip for a Lyrics Writer genre label; null when none fits (→ custom). */
export function styleKeyForGenre(genre = "") {
  const g = String(genre).trim().toLowerCase();
  if (!g) return null;
  const exact = ALL_STYLES.find((s) => s.key !== "custom" && s.label.toLowerCase() === g);
  if (exact) return exact.key;
  let best = null;
  const consider = (key, name) => {
    if (new RegExp(`(^|[^a-z])${escapeRe(name)}([^a-z]|$)`).test(g) && (!best || name.length > best.len)) best = { key, len: name.length };
  };
  for (const [key, names] of Object.entries(ALIASES)) for (const n of names) consider(key, n);
  for (const s of ALL_STYLES) if (s.key !== "custom") consider(s.key, s.label.toLowerCase());
  return best?.key || null;
}

/** Save lyrics into the Simple-mode draft and return the /create/song URL to open. */
export function handoffToCreator({ title = "", lyrics = "", genre = "", mood = "" }) {
  const styleKey = styleKeyForGenre(genre);
  let draft = {};
  try { draft = JSON.parse(localStorage.getItem(CREATOR_DRAFT_KEY) || "{}") || {}; } catch (e) { void e; }
  const next = {
    ...draft,
    title: title || draft.title || "",
    lyrics,
    styleKey: styleKey || "custom",
    customStyle: styleKey ? "" : [genre, mood].filter(Boolean).join(", "),
    voice: draft.voice === "instrumental" ? "male" : (draft.voice || "male"),
    advanced: { ...(draft.advanced || {}), referenceFile: null },
  };
  try { localStorage.setItem(CREATOR_DRAFT_KEY, JSON.stringify(next)); } catch (e) { void e; }
  setStudioMode("simple");
  return styleKey ? `/create/song?style=${encodeURIComponent(styleKey)}` : "/create/song";
}
